import React from 'react';
import GeoScan from '../../components/GeoScan/GeoScan';
import Canonical from '../../utils/Canonical';

const GeoScanPage = () => {
  return (
    <>
      <Canonical path='/blog-auditor' title='Blog Auditor' />
      <GeoScan />
    </>
  );
};

export default GeoScanPage;
